import {Component, OnInit} from '@angular/core';
import {User} from "../models/user";
import {Organization} from "../models/organization";
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {AuthenticationService} from "../services/authentication.service";
import {OrganizationService} from "../services/organization.service";
import {firstValueFrom} from "rxjs";
import {NgClass, NgIf} from "@angular/common";

@Component({
  selector: 'app-my-organization-contact-change',
  templateUrl: './my-organization-contact-change.component.html',
  styleUrls: ['./my-organization-contact-change.component.css'],
  imports: [
    ReactiveFormsModule,
    NgClass,
    NgIf
  ],
  standalone: true
})
export class MyOrganizationContactChangeComponent implements OnInit {
  user!: User;
  organization!: Organization;

  organizationForm= new FormGroup({
    organizationContactName: new FormControl<string>('',
      [
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(50)
      ]
    ),
    organizationContactPhone: new FormControl<string>('',
      [
        Validators.required,
        Validators.pattern("(^\\+[0-9]{2}|^\\+[0-9]{2}\\(0\\)|^\\(\\+[0-9]{2}\\)\\(0\\)|^00[0-9]{2}|^0)([0-9]{9}$|[0-9\\-\\s]{10}$)")
      ]
    )
  });
  formSubmitted = false;

  constructor(
    private authService: AuthenticationService,
    private orgService: OrganizationService
  ) {}

  async ngOnInit() {
    this.user = await this.authService.getUser();
    this.organization = await firstValueFrom(this.orgService.getOrganizationByRef(this.user.organization));

    this.organizationForm.controls['organizationContactName'].setValue(this.organization.contactName);
    this.organizationForm.controls['organizationContactPhone'].setValue(this.organization.contactPhone);
  }

  async updateOrganization() {
    if(!this.organizationForm.valid) {
      this.formSubmitted = false;
      return;
    }

    await this.orgService.changeOrganizationContact(this.organization.id, <string>this.organizationForm.controls['organizationContactName'].value, <string>this.organizationForm.controls['organizationContactPhone'].value);
    this.formSubmitted = true;
  }

  /**
   * @return Filled in organization contact name value on organization form.
   */
  get organizationContactName() {
    return this.organizationForm.get('organizationContactName');
  }

  /**
   * @return Filled in organization contact phone number value on organization form.
   */
  get organizationContactPhone() {
    return this.organizationForm.get('organizationContactPhone');
  }
}
